import {
  FooterWrapper,
  Container,
  Left,
  Logo,
  Description,
  Column,
  Title,
  LinkItem,
  Socials
} from "./Footer.styles";
import { FaTelegramPlane, FaInstagram } from "react-icons/fa";

import { BizningKurslar } from '../../pages/bizningKurslarimiz/BizningKurslarimizData'


import logo from "../../assets/footer_logo.png";

const Footer = () => {
  return (
    <FooterWrapper>
      <Container className="max-width">

        {/* LEFT */}
        <Left>
          <Logo src={logo} alt="logo" />
          <Description>
            Innovatsiya va texnologiya orqali O‘zbekiston yoshlarini dunyoga tanitish
          </Description>
        </Left>

        {/* NAVIGATION */}
        <Column>
          <Title>Navigatsiya</Title>
          <LinkItem>Bosh sahifa</LinkItem>
          <LinkItem>Kurslar</LinkItem>
          <LinkItem>Ustozlar</LinkItem>
          <LinkItem>Online kurslar </LinkItem>

        </Column>

        {/* COURSES */}
        <Column>
          <Title>Kurslar</Title>
          {BizningKurslar.map((item, index) => (
            <LinkItem>{item.nomi}</LinkItem>

          ))}

        </Column>

        {/* CONTACT */}
        <Column>
          <Title>Aloqa</Title>
          <LinkItem href="tel:+998886110440">+998 (88) 611-04-40</LinkItem>

          <Socials>
            {/* <SocialIcon className="bx bxl-twitter" />
            <SocialIcon className="bx bxl-facebook" /> */}
            <a
              href="https://t.me/it_tat_qabul"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "white" }}
            >
              
            <FaTelegramPlane />
            </a>
          
          <a href="https://instagram.com/it_tat_samarkand" style={{ color: 'white' }}>

            <FaInstagram />
          </a>

        </Socials>
      </Column>

    </Container>
    </FooterWrapper >
  );
};

export default Footer;